/* eslint frontbucket-patterns/no-new-sagas: "warn" */
import { call, put, select, delay } from 'redux-saga/effects';

import { mergeCheckPayloadTransformer } from 'src/redux/pull-request/sagas/utils/merge-check-payload-transformer';
import {
  getCurrentPullRequestUrlPieces,
  getPullRequestMergeChecks,
} from 'src/redux/pull-request/selectors';
import { urls } from 'src/redux/pull-request/urls';
import { getPullRequestApis } from 'src/sagas/helpers';
import { MergeCheck, MergeCheckKey } from 'src/types';

import { FETCH_MERGE_CHECKS } from '../actions';

import { fetchPendingMergeStatusSaga } from './fetch-pending-merge-status-saga';

export function* fetchMergeChecksSaga(
  user: string,
  slug: string,
  pullRequestId: string | number
) {
  const api = yield* getPullRequestApis();
  const mergeCheckUrl = urls.api.internal.mergeChecks(
    user,
    slug,
    pullRequestId
  );

  try {
    yield put({ type: FETCH_MERGE_CHECKS.REQUEST });
    // @ts-ignore
    const response = yield call(api.getMergeChecks, mergeCheckUrl);

    yield put({
      type: FETCH_MERGE_CHECKS.SUCCESS,
      // label is null for checks that aren't run
      payload: mergeCheckPayloadTransformer(response),
    });
  } catch (e) {
    yield put({
      type: FETCH_MERGE_CHECKS.ERROR,
      payload: e.message,
    });
  }
}

export function* retryFetchMergeChecks() {
  const { owner, slug, id } = yield select(getCurrentPullRequestUrlPieces);
  yield* fetchMergeChecksSaga(owner, slug, id);
  yield* fetchPendingMergeStatusSaga();
}

export function* retryFetchConcreteMergeChecks(keys: MergeCheckKey[]) {
  const mergeChecks: MergeCheck[] = yield select(getPullRequestMergeChecks);
  const hasGivenMergeKeys = mergeChecks.some(c => keys.includes(c.key));
  if (hasGivenMergeKeys) {
    yield delay(1000);
    yield* retryFetchMergeChecks();
  }
}

export function* retryFetchAllMergeChecksIfNeeded() {
  const mergeChecks: MergeCheck[] = yield select(getPullRequestMergeChecks);
  if (mergeChecks.length) {
    yield* retryFetchMergeChecks();
  }
}
